import { environment } from '../../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  // Service used for booking item and booking item service item

  angular.module('app').service('BookingItemNotificationService', BookingItemNotificationService);

  BookingItemNotificationService.$inject = [
    'RestResource',
    'UtilService',
    '$translate',
    '$filter',
    'BookingItemNotificationModalService',
    'WindowModalService',
    'UploadService',
  ];

  function BookingItemNotificationService(
    RestResource,
    UtilService,
    $translate,
    $filter,
    BookingItemNotificationModalService,
    WindowModalService,
    UploadService
  ) {
    let utils = new UtilService(this);

    $translate = $filter('translate');

    let apiUrl = environment.apiEndpoint + 'bookings';

    let service = {
      openUpdateBookingItemNotification: openUpdateBookingItemNotification,
      openBookingItemNotificationInfo: openBookingItemNotificationInfo,
      saveBookingItemNotification: saveBookingItemNotification,
      openSendBookingItemNotificationToProvider: openSendBookingItemNotificationToProvider,
      reSendBookingItemNotificationToProvider: reSendBookingItemNotificationToProvider,
      openSendNotificationToPreviousProvider: openSendNotificationToPreviousProvider,
    };

    return service;

    ////////////////

    function openUpdateBookingItemNotification(
      booking,
      bookingItem,
      bookingItemServiceItem,
      notification,
      successCallback
    ) {
      let notificationOriginal = angular.copy(notification); // !important

      BookingItemNotificationModalService.openUpdateBookingItemNotification(
        booking,
        bookingItem,
        bookingItemServiceItem,
        notificationOriginal,
        successCallback
      );
    }

    function openBookingItemNotificationInfo(
      booking,
      bookingItem,
      bookingItemServiceItem,
      notification
    ) {
      let templateUrl =
        './app/ajs/bookings/booking-items/booking-item-notification/modals/booking-item-notification-info-modal.html';

      let modalParams = {
        title: 'NOTIFICATION_DETAILS',
        item: notification,
        additionalParams: {
          bookingItem: bookingItem,
          bookingItemServiceItem: bookingItemServiceItem,
          booking: booking,
        },
      };

      WindowModalService.open(templateUrl, modalParams);
    }

    // save booking item / booking item service item
    // create the respective notification
    function saveBookingItemNotification(
      bookingId,
      bookingItemId,
      bookingItemServiceItemId,
      notification,
      params,
      file
    ) {
      let url = apiUrl + '/' + bookingId + '/booking_items/' + bookingItemId;

      // Booking item != Booking it service item
      if (!bookingItemServiceItemId) {
        url += '/booking_item_notifications';
        params.booking_item_notification = notification;
      } else {
        url +=
          '/booking_item_service_items/' +
          bookingItemServiceItemId +
          '/booking_item_service_item_notifications';
        params.booking_item_service_item_notification = notification;
      }

      if (!params.fast_confirmation) {
        params.fast_confirmation = false; // status changed so we update fast confirmation
      }

      let method = 'post';
      let msg;

      // console.log(notification);
      // return;

      // if (!notification.id) { // New
      switch (notification.status) {
        case 'requested':
          msg = 'REQUEST_SENT';
          break;
        case 'confirmed':
          msg = 'SERVICE_CONFIRMED';
          break;
        case 'declined':
          msg = 'SERVICE_DECLINED';
          break;
        case 'cancelled':
          msg = 'SERVICE_CANCELED';
          break;
        default:
          msg = 'STATUS_MODIFIED';
          break;
      }

      if (notification.id) {
        url += '/' + notification.id;
        method = 'put';
      }

      return UploadService.uploadFile(
        method,
        url,
        null,
        params,
        file,
        function () {},
        function () {
          if (msg) {
            utils._successMsg($translate(msg));
          }
        },
        function (response) {
          utils._errorMsg(response.error);
        }
      );
    }

    function openSendBookingItemNotificationToProvider(
      companyId,
      bookingItem,
      bookingItemServiceItem,
      notification,
      successCallback
    ) {
      let notificationOriginal = angular.copy(notification); // !important
      let bookingItemOriginal = angular.copy(bookingItem); // !important
      let bookingItemServiceItemOriginal = angular.copy(bookingItemServiceItem); // !important

      BookingItemNotificationModalService.openSendBookingItemNotificationToProvider(
        companyId,
        bookingItemOriginal,
        bookingItemServiceItemOriginal,
        notificationOriginal,
        successCallback
      );
    }

    function reSendBookingItemNotificationToProvider(
      bookingId,
      bookingItemId,
      bookingItemServiceItemId,
      notificationId,
      params
    ) {
      let url = apiUrl + '/' + bookingId + '/booking_items/' + bookingItemId;

      // Booking item != Booking it service item
      if (!bookingItemServiceItemId) {
        url += '/booking_item_notifications/' + notificationId + '/send_notification_to_provider';
      } else {
        url +=
          '/booking_item_service_items/' +
          bookingItemServiceItemId +
          '/booking_item_service_item_notifications/' +
          notificationId +
          '/send_notification_to_provider';
      }

      function success() {
        utils._successMsg($translate('REQUEST_SENT'));
        return true;
      }
      function failure() {
        utils._errorMsg($translate('PROBLEMS_SENDING_THE_REQUEST'));
        return false;
      }

      return RestResource.request('put', url, params, success, failure);
    }

    function openSendNotificationToPreviousProvider(
      companyId,
      bookingItem,
      bookingItemServiceItem,
      newProvider,
      confirm_callback,
      successCallback
    ) {
      let bookingItemOriginal = angular.copy(bookingItem); // !important
      let bookingItemServiceItemOriginal = angular.copy(bookingItemServiceItem); // !important
      let newProviderData = angular.copy(newProvider);

      BookingItemNotificationModalService.openSendNotificationToPreviousProvider(
        companyId,
        bookingItemOriginal,
        bookingItemServiceItemOriginal,
        newProviderData,
        confirm_callback,
        successCallback
      );
    }
  }
})();
